import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtIcon, TtDropdown, TtMenu, TtMenuItem } from '@23/ui-react'

import { useWebinarDesignQuery } from '../../../../Designs/blocs/useWebinarDesign'
import { addNewMix, setEditingMix } from '../../../../firebase/hooks/useMixes'
import type { Layout } from '../../../../firebase/model/mix'
import { LayoutPreview } from '../LayoutPreview/LayoutPreview'

import './NewMix.scss'

const NewMix = () => {
  const { data: webinarDesign } = useWebinarDesignQuery()

  const customLayouts = webinarDesign?.designData['custom-layouts']

  return (
    <TtDropdown placement="top">
      <button slot="trigger" className="new-mix-trigger" type="button">
        <TtIcon library="one" name="plus" />
        <div className="new-mix-trigger-label ">
          <FormattedMessage defaultMessage="New Mix" />
        </div>
      </button>
      <TtMenu
        className="new-mix-layouts-preview"
        onTtSelect={async (event) => {
          const selected = event.detail.item
          const idx = +selected.value
          const layout: Layout = {
            name: customLayouts?.[idx].name,
            // @ts-expect-error — TODO: fix
            settings: customLayouts?.[idx].settings ?? {},
            // @ts-expect-error — TODO: fix
            elements: customLayouts?.[idx].elements ?? [],
          }
          const newMixId = await addNewMix(layout)
          setEditingMix(newMixId)
        }}
      >
        {customLayouts?.map((layout, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <TtMenuItem key={idx} value={String(idx)}>
            {/* @ts-expect-error — TODO: fix */}
            <LayoutPreview layout={layout} />
            {/*<div>{layout.name}</div>*/}
          </TtMenuItem>
        ))}
      </TtMenu>
    </TtDropdown>
  )
}

export { NewMix }
